import React from 'react'
import './s5.scss';
import Collapse from "./Collapse";

const data = [
  {
    title: "Q: ¿Cuáles son los requisitos para solicitar un préstamo?",
    content: "A: Es necesario tener al menos 18 años, contar con una fuente de ingresos estable y un buen historial crediticio."
  },
  {
    title: "Q: ¿Qué documentos se deben preparar para solicitar un préstamo?",
    content: "A: Se requiere identificación oficial, tarjeta bancaria, número de teléfono móvil, entre otros."
  },
  {
    title: "Q: ¿Cómo es el proceso de solicitud del préstamo?",
    content: "A: El proceso es el siguiente: registrarse e iniciar sesión -> completar la información de la solicitud -> enviar los documentos -> esperar la revisión -> aprobación -> desembolso del préstamo."
  },
  {
    title: "Q: ¿Cuánto tiempo toma solicitar un préstamo?",
    content: "A: Generalmente, el proceso de solicitud puede completarse en solo unos minutos."
  },
  {
    title: "Q: ¿Qué hacer si mi solicitud de préstamo es rechazada?",
    content: "A: Puede revisar las razones del rechazo y, según la causa, modificar la información antes de volver a solicitar."
  },
  {
    title: "Q: ¿Cuál es el monto del préstamo?",
    content: "A: El monto del préstamo varía según el producto de préstamo y las condiciones del solicitante. El monto específico se determinará una vez que el préstamo sea aprobado."
  },
  {
    title: "Q: ¿Cuál es la tasa de interés del préstamo?",
    content: "A: La tasa de interés varía según el producto de préstamo y las condiciones del solicitante. La tasa final se determinará al momento de la aprobación."
  },
  {
    title: "Q: ¿Puedo pagar el préstamo antes de tiempo?",
    content: "A: Se permite el pago anticipado del préstamo, lo que puede ayudar a mejorar su historial crediticio."
  },
  {
    title: "Q: ¿Qué consecuencias tiene el pago tardío del préstamo?",
    content: "A: El pago tardío generará cargos por penalización e impactará negativamente en su historial crediticio. Se recomienda realizar los pagos a tiempo para evitar demoras."
  },
  {
    title: "Q: ¿Qué hacer si tengo problemas para pagar el préstamo?",
    content: "A: Puede ponerse en contacto con el servicio de atención al cliente de la aplicación para recibir asistencia."
  },
  {
    title: "Q: ¿Está segura mi información personal?",
    content: "A: Utilizamos tecnologías de encriptación avanzadas para proteger la seguridad de la información del usuario, por lo que puede usar nuestro servicio con confianza."
  },
  {
    title: "Q: ¿Cómo puedo cerrar mi cuenta?",
    content: "A: Si desea cerrar su cuenta, puede contactar al servicio de atención al cliente dentro de la aplicación o enviar una solicitud de cancelación de cuenta a la dirección de correo electrónico support@gogocredi.com. Para garantizar la seguridad de su cuenta, asegúrese de que no haya préstamos pendientes antes de solicitar la cancelación. Después de recibir la solicitud, GoGo Credi tiene 20 días para responder. Si se acepta la solicitud, se procesará en un plazo de 15 días hábiles. Si la solicitud está incompleta o faltan documentos para verificar su identidad, GoGo Credi pedirá la corrección en un plazo de 5 días hábiles. Usted tiene 10 días hábiles para corregir la información faltante; de lo contrario, la solicitud se considerará no presentada. Después de cancelar la cuenta, toda su información será eliminada y no podrá recuperarse, así que tenga cuidado al tomar esta decisión. Si tiene alguna pregunta, no dude en ponerse en contacto con nuestro servicio de atención al cliente."
  }
]

const S5 = () => {
  return (
    <div className="gogo-s-5">
      <p className="s-title">Preguntas frecuentes</p>
      <div className="data-wrapper">
        {
          data.map((item, index) => (
            <Collapse
              key={index}
              title={item.title}
              content={item.content}
            />
          ))
        }
      </div>
      <div className="dollar-9 absolute"></div>
      <div className="dollar-10 absolute"></div>
      <div className="dollar-11 absolute"></div>
      <div className="spark-5 absolute"></div>
      <div className="spark-6 absolute"></div>
    </div>
  )
}

export default S5;
